import { Badge } from '../Badge/Badge'
import { getBuildStatusBadgeColor } from './helpers/getBuildStatusBadgeColor'
import type { BuildStatusBadgeProps } from './BuildStatusBadge.types'

export function BuildStatusBadge({ status }: BuildStatusBadgeProps) {
  return <Badge color={getBuildStatusBadgeColor(status)}>{status}</Badge>
}
